const Center = require('./Center');
const Child = require('./Child');
const Parent = require('./Parent');

class Lead {
  constructor() {
    this.init();
  }

  init() {
    this.lead_id = undefined;
    this.center = undefined;
    this.parents = undefined;
    this.child = undefined;
    this.family_notes = undefined;
    this.internal_notes = undefined;
    this.state = undefined;
    this.source = undefined;
  }

  copy() {
    const cp = new Lead();

    cp.lead_id = this.lead_id;
    cp.family_notes = this.family_notes;
    cp.internal_notes = this.internal_notes;
    cp.state = this.state;
    cp.source = this.source;
    
    if (this.center) {
      cp.center = this.center.copy();
    }
    if (this.child) {
      cp.child = this.child.copy();
    }
    if (this.parents) {
      cp.parents = this.parents.map((p) => p.copy());
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.lead_id = obj.lead_id ? obj.lead_id.toString() : undefined;
      this.family_notes = obj.family_notes ? obj.family_notes : undefined;
      this.internal_notes = obj.internal_notes ? obj.internal_notes : undefined;
      this.state = obj.state ? obj.state : undefined;
      this.source = obj.source ? obj.source : undefined;

      if (obj.center) {
        this.center = new Center();
        this.center.buildFromJSON(obj.center);
      }
      if (obj.child) {
        this.child = new Child();
        this.child.buildFromJSON(obj.child);
      }
      if (obj.parents) {
        this.parents = [];
        obj.parents.forEach((p) => {
          const parent = new Parent();
          parent.buildFromJSON(p);
          this.parents.push(parent);
        })
      }
    }
  }

  toString() {
    let result = this.lead_id ? this.lead_id : '';
    return result;
  }

  getId() {
    return this.lead_id;
  }

  setId(lead_id) {
    this.lead_id = lead_id ? lead_id.toString() : undefined;
  }

  getCenter() {
    return this.center;
  }

  setCenter(center) {
    this.center = center ? center.copy() : undefined;
  }

  getFamilyNotes() {
    return this.family_notes;
  }

  setFamilyNotes(family_notes) {
    this.family_notes = family_notes;
  }

  getInternalNotes() {
    return this.internal_notes;
  }

  setInternalNotes(internal_notes) {
    this.internal_notes = internal_notes;
  }
  
  getState() {
    return this.state;
  }

  setState(state) {
    this.state = state;
  }

  getSource() {
    return this.source;
  }

  setSource(source) {
    this.source = source;
  }

  getParents() {
    return this.parents;
  }

  setParents(parents) {
    this.parents = (parents) ? parents.map((p) => p.copy()) : undefined;
  }

  getChild() {
    return this.child;
  }

  setChild(child) {
    this.child = (child) ? child.copy() : undefined;
  }
}

module.exports = Lead;
